import { FiExternalLink } from 'react-icons/fi';

/*
    La apariencia (light/dark) ya vive en el header privado del Core.
    No se duplica aca: esta cabecera solo contiene contexto de la vista
    y acciones propias de la pantalla.
*/
export const AdminPageHeader = ({ eyebrow = 'Portfolio Studio', title, description, actions = null }) => (
    <div className="PBADMIN__page_header">
        <div className="PBADMIN__page_heading">
            <span>{eyebrow}</span>
            <h1>{title}</h1>
            {description && <p>{description}</p>}
        </div>
        <div className="PBADMIN__page_actions">
            {actions}
            <a className="PBADMIN__site_link" href="/" target="_blank" rel="noreferrer">
                <FiExternalLink /> Ver portfolio
            </a>
        </div>
    </div>
);
